import { makeStyles } from 'tss-react/mui'

const useStylesHook = makeStyles()(theme => ({
  listItems: {
    '& li': {
      marginLeft: theme.spacing(-2.5),
    },
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    '& ul li::marker': {
      fontSize: '12px',
      lineHeight: '1',
    },
  },
  note: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.labraText.tertiary,
  },
  noteWrapper: {
    padding: theme.spacing(1.5, 1.5, 0, 1.5),
  },
  noteWrapper2: {
    padding: theme.spacing(1.5, 0, 0, 0),
  },
  noteTitle: {
    fontWeight: 500,
  },
  noteDescription: {
    fontWeight: 400,
    paddingLeft: theme.spacing(0.5),
  },
  tipNote: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  noteIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(1.625),
    height: theme.spacing(2.125),
  },
  boldText: {
    fontWeight: 500,
  },
  tableWrapper: {
    border: `1px solid ${theme.palette.dividerV2?.main || '#e2e2e2'}`,
    borderRadius: theme.spacing(0.5),
    marginTop: theme.spacing(1.5),
    width: theme.spacing(33.375),
    overflow: 'hidden',
    padding: theme.spacing(0.125),
  },
  tableRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    width: '100%',
  },
  tableCell: {
    flex: 1,
    backgroundColor: theme.palette.text.white,
    padding: theme.spacing(1, 1.25),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  },
  tableText: {
    fontFamily: theme.typography.fontFamily,
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText?.primary,
  },
  tableDivider: {
    backgroundColor: theme.palette.dividerV2?.main,
    height: theme.spacing(0.125),
    width: '100%',
  },
  sublistItems: {
    listStyleType: 'disc',
    '& li': {
      marginLeft: `${theme.spacing(-7.5)} !important`,
    },
  },
  signWidth: {
    width: theme.spacing(1),
  },
}))

export const useStyles = useStylesHook
export type MicrosoftFormFAQsClasses = ReturnType<
  typeof useStylesHook
>['classes']
